import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {RouterService, Spinner, TAB} from '@npck/libs/commons';
import {AuthHolderService} from '../../domain/auth-holder.service';
import {Path} from '../../path';

@Component({
    templateUrl: 'knowledge-base.component.html',
    styleUrls: ['knowledge-base.component.scss'],
    standalone: false,
})
export class KnowledgeBaseComponent {
    Spinner = Spinner;
    tabs: KnowledgeBaseTab[] = ['tabFaq', 'tabDocuments'];
    isAdmin = this.authHolderService.hasAccess(['npck-admin']);
    hasAddButton = this.authHolderService.hasAccess(['npck-admin']);
    activeTab: KnowledgeBaseTab = this.activatedRoute.snapshot.queryParamMap.get(TAB) as KnowledgeBaseTab || 'tabFaq';
    selectedTabIndex = this.tabs.findIndex(tab => tab === this.activeTab);

    constructor(
        private authHolderService: AuthHolderService,
        private activatedRoute: ActivatedRoute,
        private routerService: RouterService,
    ) {
    }

    handleNavigation(index: number): void {
        this.activeTab = this.tabs[index];
        this.hasAddButton = false;
        this.routerService.navigate(Path.KNOWLEDGE_BASE, {queryParams: {[TAB]: this.activeTab}});
    }

    addQuestion(): void {
        this.routerService.navigate(Path.FAQ_CREATE);
    }

    addDocument = (): void => {
        this.routerService.navigate(Path.KNOWLEDGE_BASE_DOC_CREATE);
    };

    navigateToArchive(): void {
        this.routerService.navigate(Path.KNOWLEDGE_BASE_ARCHIVE);
    }

    onHasData(hasData: boolean): void {
        this.hasAddButton = this.authHolderService.hasAccess(['npck-admin']) && hasData;
    }

}

export declare type KnowledgeBaseTab = 'tabFaq' | 'tabDocuments';
